import omit from 'lodash.omit';
import pick from 'lodash.pick';
import { PersistStorage, StorageValue } from 'zustand/middleware';

export interface StorageMiddlewareOptions<S = unknown, K = NestedKeyOf<StorageValue<S>['state']>> {
  exclude?: K[];
  include?: K[];
}

// function isCyclic(obj: any) {
//   var seenObjects: any[] = [];

//   function detect(obj) {
//     if (typeof obj === 'object') {
//       if (seenObjects.indexOf(obj) !== -1) {
//         return true;
//       }
//       seenObjects.push(obj);
//       for (var key in obj) {
//         if (obj.hasOwnProperty(key) && detect(obj[key])) {
//           return true;
//         }
//       }
//     }
//     return false;
//   }

//   return detect(obj);
// }

export class StorageMiddleware<S = unknown> implements PersistStorage<S> {
  store: PersistStorage<S>;
  options: StorageMiddlewareOptions<S>;
  enabled = true;

  constructor(store: PersistStorage<S>, options?: StorageMiddlewareOptions<S>) {
    this.store = store;
    this.options = { ...options };
  }

  async getItem(name: string): Promise<StorageValue<S> | null> {
    return (await this.store.getItem(name)) || null;
  }

  async setItem(name: string, value: StorageValue<S>): Promise<void> {
    if (!this.enabled) {
      return;
    }

    const { exclude, include } = this.options;
    let state = value.state as any;

    state = include ? pick(state, include) : state;
    state = exclude ? omit(state, exclude) : state;

    await this.store.setItem(name, {
      ...value,
      state: state,
      // state: JSON.parse(
      //   JSON.stringify(state, (key, value) => {
      //     console.log(key, value, isCyclic(value));
      //     return isCyclic(value) ? { ...value } : value;
      //   })
      // ),
    });
  }

  async removeItem(name: string): Promise<void> {
    await this.store.removeItem(name);
  }
}
